import styled from 'styled-components';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Dropdown from 'react-bootstrap/Dropdown';

import { AiFillDelete } from 'react-icons/ai';

import { LuEllipsisVertical } from 'react-icons/lu';

import { deleteMasterFeatures } from '@utils/api';
import { useToast } from '@contexts/Toast.context';
import { useProject } from '@contexts/Project.context';
import { useConfirm } from '@contexts/Confirm.context';

const DropdownToggle = styled(Dropdown.Toggle)`
	background: none;
	padding: 0;
	font-size: 1.2em;
	&.dropdown-toggle::after {
		display: none;
	}
`;

const ModelResultDropdown = () => {
	const { confirm } = useConfirm();
	const { project, pickedTask, isDemo } = useProject();
	const { model_uuid: modelUuid, description: modelName } = pickedTask ?? {};
	const { uuid: projectUuid } = project ?? {};

	const queryClient = useQueryClient();
	const { addToast } = useToast();

	const { mutate: deleteModelResults } = useMutation({
		mutationFn: deleteMasterFeatures,
		onSuccess: res => {
			console.log(res);

			addToast({
				id: 'delete-model-result-success',
				title: 'Model result deleted successfully',
				bg: 'success',
			});

			queryClient.invalidateQueries({ queryKey: ['models_detected_on'] });
			queryClient.invalidateQueries({
				predicate: ({ queryKey }) => queryKey.includes(modelUuid),
			});
		},
		onError: error => {
			console.error('Error deleting model result', error);
			addToast({
				id: 'delete-model-result-error',
				title: 'Error deleting model result',
				bg: 'danger',
			});
		},
	});

	const handleDelete = async () => {
		const userConfirmed = await confirm({
			title: 'Confirm Deletion',
			message: (
				<p>
					Are you sure you want to delete the model result for{' '}
					<strong>{modelName}</strong>?
				</p>
			),
		});

		if (userConfirmed) deleteModelResults({ projectUuid, modelUuid });
	};

	return (
		<>
			<Dropdown>
				<DropdownToggle variant="dark">
					<LuEllipsisVertical />
				</DropdownToggle>
				<Dropdown.Menu variant="dark">
					<Dropdown.Item as="button" onClick={handleDelete} disabled={isDemo}>
						<AiFillDelete className="mt-1 mb-2 me-2" aria-hidden="true" />
						Delete Results
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</>
	);
};
export default ModelResultDropdown;
